import Vue from 'vue'
import Router from 'vue-router'
import wujie from './wujie.js'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //     path: '/office',
    //     name: 'excel',
    //     component: () => import('@/components/office/excel'),
    // },
    {
      path: '/',
      name: 'Index',
      component: () => import('@/components/Index'),
      children: [{
          path: '/',
          name: 'BigScreen',
          component: () => import('@/components/wujie'),
          props: {
            type: 'office'
          },
          meta: {
            title: "首页"
          }
        },
        {
          path: 'staging',
          name: 'Staging',
          component: () => import('@/components/Admin/Oa/Staging'),
          props: {
            type: 'office'
          },
          meta: {
            title: "工作台汇总"
          }
        },
        //模板
        {
          path: 'mb',
          name: 'mb',
          component: () => import('@/components/Admin/mb'),
          children: [{
              path: 'mbs',
              component: () => import('@/components/Admin/mbd/mbs')
            },
            {
              path: 'mbc',
              component: () => import('@/components/Admin/mbd/mbc')
            },
          ],
          meta: {
            title: "操作"
          }
        },

        //项目
        {
          path: 'pindex',
          name: 'pindex',

          component: () => import('@/components/Admin/Project/project'),
          children: [
            // {
            //   path: '/',
            //   name: "projectIndex",
            //   component: () => import('@/components/Admin/Project/index'),
            //   meta: {
            //     title: "项目管理"
            //   }
            // },
            {
              path: 'index',
              name: "projectIndex",
              component: () => import('@/components/Admin/Project/index'),
              meta: {
                title: "项目管理"
              }
            },
            {
              path: 'houseManagement',
              name: "HouseManagement",
              component: () => import('@/components/Admin/Project/HouseManagement'),
              meta: {
                title: "房产管理"
              }
            },
            {
              path: 'houseManage',
              name: "HouseManage",
              component: () => import('@/components/Admin/Project/HouseManage'),
              meta: {
                title: "房产管理"
              }
            },
            {
              path: 'zone',
              name: "ZoneManage",
              component: () => import('@/components/Admin/Project/ZoneManage'),
              meta: {
                title: "战区管理"
              }
            },
            {
              path: 'Import',
              name: "pindexImport",
              component: () => import('@/components/Admin/Project/Import'),
              meta: {
                title: "房产导入"
              }
            },
            {
              path: 'Examine',
              name: "pindexExamine",
              component: () => import('@/components/Admin/Project/Examine'),
              meta: {
                title: "房产审核"
              }
            },
            {
              path: 'Charge',
              name: "pindexCharge",
              component: () => import('@/components/Admin/Project/Charge'),
              meta: {
                title: "收费标准设置"
              }
            },
            {
              path: 'room/RoomSetUp',
              name: "room/RoomSetUp",
              component: () => import('@/components/Admin/Project/room/RoomSetUp'),
              meta: {
                title: "房间收费设置"
              }
            },
            {
              path: 'room/RoomSetUpUser',
              name: "room/RoomSetUpUser",
              component: () => import('@/components/Admin/Project/room/RoomSetUpUser'),
              meta: {
                title: "房间收费对象设置"
              }
            },
            {
              path: 'share/ShareSetUp',
              name: "share/ShareSetUp",
              component: () => import('@/components/Admin/Project/share/ShareSetUp'),
              meta: {
                title: "分摊费用设置"
              }
            },
            {
              path: 'RoutineExpense',
              name: "RoutineExpense",
              component: () => import('@/components/Admin/Project/expense/RoutineExpense'),
              meta: {
                title: "常规费用管理"
              }
            },


            {
              path: 'MeterExpense',
              name: "MeterExpense",
              component: () => import('@/components/Admin/Project/expense/MeterExpense'),
              meta: {
                title: "仪表费用管理"
              }
            },
            {
              path: 'ShareExpense',
              name: "ShareExpense",
              component: () => import('@/components/Admin/Project/expense/ShareExpense'),
              meta: {
                title: "分摊费用管理"
              }
            },



            {
              path: 'TemporaryExpense',
              name: "TemporaryExpense",
              component: () => import('@/components/Admin/Project/expense/TemporaryExpense'),
              meta: {
                title: "临时费用管理"
              }
            },
            {
              path: 'MoneyCheck',
              name: "MoneyCheck",
              component: () => import('@/components/Admin/Project/expense/MoneyCheck'),
              meta: {
                title: "应收款审核"
              }
            },
            {
              path: 'Allocation',
              name: "pindexAllocation",
              component: () => import('@/components/Admin/Project/Allocation'),
              meta: {
                title: "生成账单"
              }
            },
            {
              path: 'Allocations',
              name: "pindexAllocations",
              component: () => import('@/components/Admin/Project/Allocations'),
              meta: {
                title: "导入费用"
              }
            },
            {
              path: 'discounts',
              name: "pindexDiscounts",
              component: () => import('@/components/Admin/Project/discounts'),
              meta: {
                title: "折扣设置"
              }
            },
            {
              path: 'Type',
              name: "pindexType",
              component: () => import('@/components/Admin/Project/Type'),
              meta: {
                title: "收费项目设置"
              }
            },
            {
              path: 'region',
              name: "pindexRegion",
              component: () => import('@/components/Admin/Project/region'),
              meta: {
                title: "区域管理"
              }
            },
            {
              path: 'regionDate',
              name: "pindexRegionDate",
              component: () => import('@/components/Admin/Project/regionDate'),
              meta: {
                title: "区域划分"
              }
            },
            {
              path: 'xsc/xsc',
              name: "xsc",
              component: () => import('@/components/Admin/Project/xsc/xsc'),
              meta: {
                title: "新视窗导入"
              }
            },
            {
              path: 'xsc/receivable',
              name: "receivable",
              component: () => import('@/components/Admin/Project/xsc/receivable'),
              meta: {
                title: "应收对账"
              }
            },
            {
              path: 'xsc/arrearage',
              name: "arrearage",
              component: () => import('@/components/Admin/Project/xsc/arrearage'),
              meta: {
                title: "欠费对账"
              }
            },
            {
              path: 'xsc/charge',
              name: "charge",
              component: () => import('@/components/Admin/Project/xsc/charge'),
              meta: {
                title: "收费对账"
              }
            },
            {
              path: 'xsc/with',
              name: "charge",
              component: () => import('@/components/Admin/Project/xsc/with'),
              meta: {
                title: "同步修改"
              }
            },
            {
              path: 'Share',
              name: "pindexShare",
              component: () => import('@/components/Admin/Project/Share'),
              meta: {
                title: "分摊费用"
              }
            },
            {
              path: 'ShareSetup',
              name: "pindexShareSetup",
              component: () => import('@/components/Admin/Project/ShareSetup'),
              meta: {
                title: "分摊设置"
              }
            },
            {
              path: 'ShareEnter',
              name: "pindexShareEnter",
              component: () => import('@/components/Admin/Project/ShareEnter'),
              meta: {
                title: "分摊导入"
              }
            },
            {
              path: 'GoodsTaxCode',
              name: "pindexGoodsTaxCode",
              component: () => import('@/components/Admin/Project/GoodsTaxCode'),
              meta: {
                title: "税目分类编码"
              }
            },
            {
              path: 'AreaTax',
              name: "pindexAreaTax",
              component: () => import('@/components/Admin/Project/AreaTax'),
              meta: {
                title: "区域收费项税率"
              }
            },
            {
              path: 'OrderDepositType',
              name: "pindexOrderDepositType",
              component: () => import('@/components/Admin/Project/OrderDepositType'),
              meta: {
                title: "分摊设置"
              }
            },
            {
              path: 'ReceivablesExcel',
              name: "pindexReceivablesExcel",
              component: () => import('@/components/Admin/Project/ReceivablesExcel'),
              meta: {
                title: "应收缴导入"
              }
            },
            {
              path: 'OrderReceivablesExcel',
              name: "pindexOrderReceivablesExcel",
              component: () => import('@/components/Admin/Project/OrderReceivablesExcel'),
              meta: {
                title: "应收缴导入"
              }
            },
            {
              path: 'PaidExcel',
              name: "pindexPaidExcel",
              component: () => import('@/components/Admin/Project/PaidExcel'),
              meta: {
                title: "已缴款导入"
              }
            },
            {
              path: 'OrderBillType',
              name: "pindexOrderBillType",
              component: () => import('@/components/Admin/Order/OrderBillType'),
              meta: {
                title: "已缴导入"
              }
            },
            {
              path: 'ReceivablesSplit',
              name: "pindexReceivablesSplit",
              component: () => import('@/components/Admin/Project/ReceivablesSplit'),
              meta: {
                title: "应收款拆分"
              }
            },
            {
              path: 'ReceivablesMerge',
              name: "pindexReceivablesMerge",
              component: () => import('@/components/Admin/Project/ReceivablesMerge'),
              meta: {
                title: "应收缴合并"
              }
            },
            {
              path: 'belong',
              name: "pindexBelong",
              component: () => import('@/components/Admin/Project/Belong'),
              meta: {
                title: "项目分类"
              }
            },
            {
              path: '/Project/Split',
              name: "/Project/Split",
              component: () => import('@/components/Admin/Project/Split'),
              meta: {
                title: "项目拆分"
              }
            },
            {
              path : 'place',
              name : 'pindexPlace',
              component : () => import('@/components/Admin/Project/Place'),
              meta : { title : '项目地区'}
            }
          ],
        },
        //订单
        {
          path: 'order',
          name: 'order',
          component: () => import('@/components/Admin/Order/Index'),
          children: [{
              path: '/',
              component: () => import('@/components/Admin/Order/List')
            },
            {
              path: 'list',
              name: "OrderList",
              component: () => import('@/components/Admin/Order/List'),
              meta: {
                title: "项目收费"
              }
            },
            {
              path: 'list2',
              name: "OrderList3",
              component: () => import('@/components/Admin/Order/List2'),
              meta: {
                title: "应收费用"
              }
            },
            {
              path: 'order',
              name: "order",
              component: () => import('@/components/Admin/Order/Order'),
              meta: {
                title: "应收费用"
              }
            },
            {
              path: 'onlineOrder',
              name: "onlineOrder",
              component: () => import('@/components/Admin/Order/OnlineOrder'),
              meta: {
                title: "POS支付"
              }
            },
            {
              path: 'order/orderAdjust',
              name: "order/orderAdjust",
              component: () => import('@/components/Admin/Order/order/orderAdjust'),
              meta: {
                title: '应收费用调整（流程）'
              }
            },

            {
              path: 'order/orderPaymentFlow',
              name: "order/orderPaymentFlow",
              component: () => import('@/components/Admin/Order/order/orderPaymentFlow'),
              meta: {
                title: '系统欠费减免流程'
              }
            },

            {
              path: 'order/orderRedFlushFlow',
              name: "order/orderRedFlushFlow",
              component: () => import('@/components/Admin/Order/order/orderRedFlushFlow'),
              meta: {
                title: '账单红冲(流程)'
              }
            },

            {
              path: 'order/orderDiscountFlow',
              name: "order/orderDiscountFlow",
              component: () => import('@/components/Admin/Order/order/orderDiscountFlow'),
              meta: {
                title: '应收款减免(流程)'
              }
            },

            {
              path: 'Users',
              name: "Users",
              component: () => import('@/components/Admin/Order/order/Users'),
              meta: {
                title: "业户调整"
              }
            },
            {
              path: 'notpaylist',
              component: () => import('@/components/Admin/Order/NotPayList')
            },
            {
              path: 'listDate',
              name: "OrderListDate",
              component: () => import('@/components/Admin/Order/listDate'),
              meta: {
                title: "缴费订单"
              }
            },
            {
              path: 'listexcel',
              component: () => import('@/components/Admin/Order/ListExcel')
            },
            {
              path: 'discountExcel',
              name: "DiscountExcel",
              component: () => import('@/components/Admin/Order/discountExcel'),
              meta: {
                title: "批量折扣/减免"
              }
            },
            {
              path: 'financeReport',
              name: "FnanceReport",
              component: () => import('@/components/Admin/Order/financeReport'),
              meta: {
                title: "财务报表"
              }
            },
            {
              path: 'temporary',
              name: "OrderTemporary",
              component: () => import('@/components/Admin/Order/temporary'),
              meta: {
                title: "临时费用"
              }
            },
            {
              path: 'clearOrder',
              name: "ClearOrder",
              component: () => import('@/components/Admin/Order/clearOrder'),
              meta: {
                title: "清除缴费"
              }
            },
            {
              path: 'deposit',
              name: "OrderDeposit",
              component: () => import('@/components/Admin/Order/deposit'),
              meta: {
                title: "押金管理"
              }
            },
            {
              path: 'advance',
              name: "OrderAdvance",
              component: () => import('@/components/Admin/Order/advance'),
              meta: {
                title: "预收款管理"
              }
            },
            {
              path: 'advanceCarry',
              name: "OrderAdvanceCarry",
              component: () => import('@/components/Admin/Order/advanceCarry'),
              meta: {
                title: "预收款结转"
              }
            },
            {
              path: 'chargeQuery',
              name: "OrderChargeQuery",
              component: () => import('@/components/Admin/Order/chargeQuery'),
              meta: {
                title: "应收款查询"
              }
            },
            {
              path: 'chargeModify',
              name: "OrderChargeModify",
              component: () => import('@/components/Admin/Order/chargeModify'),
              meta: {
                title: "应收款调整"
              }
            },
            {
              path: 'monthClosing',
              name: "OrderMonthClosing",
              component: () => import('@/components/Admin/Order/monthClosing'),
              meta: {
                title: "月结"
              }
            },
            {
              path: 'bankDeduction',
              name: "OrderBankDeduction",
              component: () => import('@/components/Admin/Order/bankDeduction'),
              meta: {
                title: "银行托收"
              }
            },
            {
              path: 'bankDeductionSetting',
              name: "OrderBankDeductionSetting",
              component: () => import('@/components/Admin/Order/bankDeductionSetting'),
              meta: {
                title: "银行托收设置"
              }
            },
            {
              path: 'billCollection',
              name: "billCollection",
              component: () => import('@/components/Admin/Order/billCollection'),
              meta: {
                title: "账单托收"
              }
            },
            {
              path : 'disAmountOrder' ,
              name : 'disAmountOrder' ,
              component : () => import('@/components/Admin/Order/disAmountOrder') ,
              meta : {
                title : '订单销账'
              }
            }
          ],
        },
        // 对账
        {
          path: 'Comparison/Receivable',
          name: 'Comparison/Receivable',
          component: () => import('@/components/Admin/Order/Comparison/Receivable'),
        },
        {
          path: 'Comparison/Arrearage',
          name: 'Comparison/Arrearage',
          component: () => import('@/components/Admin/Order/Comparison/Arrearage'),
        },
        {
          path: 'Comparison/Charge',
          name: 'Comparison/Charge',
          component: () => import('@/components/Admin/Order/Comparison/Charge'),
        },
        {
          path: 'Comparison/Money',
          name: 'Comparison/Money',
          component: () => import('@/components/Admin/Order/Comparison/Money'),
        },

        //收入日报
        {
          path: 'OrderDaily',
          name: 'OrderDaily',
          component: () => import('@/components/Admin/OrderDaily/Index'),
          children: [
            // {
            //   path: '/',
            //   name: "OrderDailyList",
            //   component: () => import('@/components/Admin/OrderDaily/List'),
            //   meta: {
            //     title: "收银日报表"
            //   }
            // },
            {
              path: 'list',
              name: "OrderDailyList",
              component: () => import('@/components/Admin/OrderDaily/List'),
              meta: {
                title: "收银日报表"
              }
            },
            {
              path: 'check',
              name: "OrderDailyCheck",
              component: () => import('@/components/Admin/OrderDaily/Check'),
              meta: {
                title: "收银日报审核"
              }
            },
            {
              path: 'flow',
              name: "OrderDailyFlow",
              component: () => import('@/components/Admin/OrderDaily/Flow'),
              meta: {
                title: "日报表流程"
              }
            },
            {
              path : 'DailyCompare',
              name : 'DailyCompare',
              component : () => import('@/components/Admin/Forms/DailyCompare'),
              meta : {
                title : '每日收入对账表',
              }
            },
            {
              path : 'PosCharge',
              name : 'PosCharge' ,
              component : () => import('@/components/Admin/Forms/PosCharge'),
              meta : {
                title : 'POS对账表'
              }
            }
          ],
        },


        //操作
        {
          path: 'operation',
          name: 'operation',
          component: () => import('@/components/Admin/Operation/Index'),
          children: [{
              path: '/',
              component: () => import('@/components/Admin/Operation/log')
            },
            {
              path: 'execl',
              component: () => import('@/components/Admin/Operation/execl')
            },
            {
              path: 'log',
              name: "OperationLog",
              component: () => import('@/components/Admin/Operation/log'),
              meta: {
                title: '日记'
              }
            },
          ],
        },
        //仪表设备
        {
          path: 'meter',
          name: 'MeterIndex',
          component: () => import('@/components/Admin/EnergyConsumption/index'),
          children: [{
              path: '/',
              component: () => import('@/components/Admin/EnergyConsumption/Meter'),
              meta: {
                title: '仪表登记'
              }
            },
            {
              path: 'meter',
              component: () => import('@/components/Admin/EnergyConsumption/Meter'),
              meta: {
                title: '仪表登记'
              }
            },
            {
              path: 'type',
              component: () => import('@/components/Admin/Meter/MeterType'),
              meta: {
                title: '仪表类型'
              }
            },
            {
              path: 'meterExcel',
              component: () => import('@/components/Admin/Meter/MeterExcel'),
              meta: {
                title: '仪表导入/导出'
              }
            },
            {
              path: 'meterNote',
              component: () => import('@/components/Admin/EnergyConsumption/MeterNote'),
              meta: {
                title: '仪表抄表'
              }
            },
            {
              path: 'meterNoteWrite',
              component: () => import('@/components/Admin/Meter/MeterNoteWrite'),
              meta: {
                title: '抄表录入'
              }
            },
            {
              path: 'meterNotePrint',
              component: () => import('@/components/Admin/Meter/MeterNotePrint'),
              meta: {
                title: '抄表打印'
              }
            },
            {
              path: 'meterNoteExcel',
              component: () => import('@/components/Admin/Meter/MeterNoteExcel'),
              meta: {
                title: '抄表导入'
              }
            },
            {
              path: 'meterNoteDetail',
              component: () => import('@/components/Admin/Meter/MeterNoteDetail'),
              meta: {
                title: '抄表明细'
              }
            },
            {
              path: 'MeterDiagram',
              component: () => import('@/components/Admin/Meter/MeterDiagram'),
              meta: {
                title: '抄表明细'
              }
            },
            // 分摊表
            {
              path: 'share/meter',
              component: () => import('@/components/Admin/Meter/share/Meter'),
              meta: {
                title: '虚拟表登记'
              }
            },
            {
              path: 'share/MeterCalculation',
              component: () => import('@/components/Admin/Meter/share/MeterCalculation'),
              meta: {
                title: '虚拟表计算'
              }
            },
            {
              path: 'share/MeterOrderSelect',
              component: () => import('@/components/Admin/Meter/share/MeterOrderSelect'),
              meta: {
                title: '虚拟表费用查询'
              }
            },
            {
              path: 'meterOrder',
              component: () => import('@/components/Admin/EnergyConsumption/MeterOrder'),
              meta: {
                title: '抄表计费'
              }
            },
            {
              path: 'ApportionTemplate',
              name: "ApportionTemplate",
              component: () => import('@/components/Admin/EnergyConsumption/ApportionTemplate'),
              meta: {
                title: "分摊模板管理"
              }
            },
            {
              path: 'MeterFeeTag',
              name: "MeterFeeTag",
              component: () => import('@/components/Admin/EnergyConsumption/MeterFeeTag'),
              meta: {
                title: "仪表合并费项"
              }
            },
            {
              path: 'meterLog',
              component: () => import('@/components/Admin/EnergyConsumption/MeterLog'),
              meta: {
                title: '仪表日志'
              }
            },
            {
              path : 'MeterPlan',
              name : 'MeterPlan',
              component : () => import('@/components/Admin/EnergyConsumption/MeterPlan'),
              meta : {
                title : '抄表计划'
              }
            }
          ],
        },

        {
          path: 'flow',
          name: 'FlowIndex',
          component: () => import('@/components/Admin/Flow/index'),
          children: [{
              path: '/',
              component: () => import('@/components/Admin/Flow/FlowMasterList'),
              meta: {
                title: '流程中心'
              }
            },
            {
              path: 'FlowMaster',
              component: () => import('@/components/Admin/Flow/FlowMaster'),
              meta: {
                title: '流程管理'
              }
            },
            {
              path: 'FlowType',
              component: () => import('@/components/Admin/Flow/FlowType'),
              meta: {
                title: '流程类型'
              }
            },
            {
              path: 'BpmnEditor',
              component: () => import('@/components/Admin/Flow/bpmn/BpmnEditor'),
              meta: {
                title: '流程编辑'
              }
            },
            {
              path: 'BpmnView',
              component: () => import('@/components/Admin/Flow/bpmn/BpmnView'),
              meta: {
                title: '流程预留'
              }
            },
            {
              path: 'FlowSheet',
              component: () => import('@/components/Admin/Flow/FlowSheet'),
              meta: {
                title: '流程编辑'
              }
            },
            {
              path: 'UserRole',
              component: () => import('@/components/Admin/Flow/UserRole'),
              meta: {
                title: '角色设置'
              }
            },
            {
              path: 'FlowView',
              component: () => import('@/components/Admin/Flow/FlowView'),
              meta: {
                title: '流程操作'
              }
            },
            {
              path: 'FlowModelList',
              component: () => import('@/components/Admin/Flow/FlowModelList'),
              meta: {
                title: '数据模型列表'
              }
            },
            {
              path: 'FlowModelDetail',
              component: () => import('@/components/Admin/Flow/FlowModelDetail'),
              meta: {
                title: '数据模型详细'
              }
            },
            {
              path: 'FlowFormDesign',
              component: () => import('@/components/Admin/Flow/FlowFormDesign'),
              meta: {
                title: '流程表单管理'
              }
            },
            {
              path: 'FlowCreate',
              component: () => import('@/components/Admin/Flow/FlowCreate'),
              meta: {
                title: '创建流程'
              }
            },
            {
              path: 'ER',
              component: () => import('@/components/Admin/Database/ER'),
              meta: {
                title: 'ER模型'
              }
            },
            {
              path: 'FlowMasterList',
              component: () => import('@/components/Admin/Flow/FlowMasterList'),
              meta: {
                title: '流程中心'
              }
            },
            {
              path: 'FlowProcessSteps',
              component: () => import('@/components/Admin/Flow/FlowProcessSteps'),
              meta: {
                title: '办理中心'
              }
            },
            {
              path: 'FlowProcessStepsDraft',
              component: () => import('@/components/Admin/Flow/FlowProcessStepsDraft'),
              meta: {
                title: '草稿'
              }
            },
            {
              path: 'FlowProcessStepsSelf',
              component: () => import('@/components/Admin/Flow/FlowProcessStepsSelf'),
              meta: {
                title: '我发起的流程'
              }
            },
            {
              path: 'FlowProcessStepsHandled',
              component: () => import('@/components/Admin/Flow/FlowProcessStepsHandled'),
              meta: {
                title: '我经办的流程'
              }
            },
            {
              path: 'FlowProfessionalType',
              component: () => import('@/components/Admin/Flow/FlowProfessionalType'),
              meta: {
                title: '业务类型'
              }
            },
            {
              path: 'FlowProfessionalWork',
              component: () => import('@/components/Admin/Flow/FlowProfessionalWork'),
              meta: {
                title: '业务管理'
              }
            },
            {
              path: 'FlowProfessionalWorkLog',
              component: () => import('@/components/Admin/Flow/FlowProfessionalWorkLog'),
              meta: {
                title: '业务日志'
              }
            },
            {
              path: 'FlowTimeoutReport',
              component: () => import('@/components/Admin/Flow/FlowTimeoutReport'),
              meta: {
                title: '流程报表'
              }
            },
            {
              path: 'FlowAbnormal',
              component: () => import('@/components/Admin/Flow/FlowAbnormal'),
              meta: {
                title: '异常流程'
              }
            },
            {
              path: 'FlowDeploy',
              component: () => import('@/components/Admin/Flow/FlowDeploy'),
              meta: {
                title: '流程转移'
              }
            },
            {
              path: 'FlowOldHistory',
              component: () => import('@/components/Admin/Flow/FlowOldHistory'),
              meta: {
                title: '流程列表'
              }
            },
            {
              path: 'FlowOldHistoryShow',
              component: () => import('@/components/Admin/Flow/FlowOldHistoryShow'),
              meta: {
                title: '流程明细'
              }
            },
            {
              path: 'CompanySetting',
              component: () => import('@/components/Admin/Flow/CompanySetting'),
              meta: {
                title: '公司配置'
              }
            },
          ],
        },

        //会员
        {
          path: 'User',
          name: 'User',
          component: () => import('@/components/Admin/User/Index'),
          children: [
            // {
            //   path: '/',
            //   name: "UserOwner",
            //   component: () => import('@/components/Admin/User/Owner'),
            //   meta: {
            //     title: "业主管理"
            //   }
            // },
            {
              path: 'Owner',
              name: "UserOwner",
              component: () => import('@/components/Admin/User/Owner'),
              meta: {
                title: "业主管理"
              }
            },
            {
              path: 'user',
              name: "User",
              component: () => import('@/components/Admin/User/user'),
              meta: {
                title: "会员管理"
              }
            },
            {
              path: 'Butler',
              name: "UserButler",
              component: () => import('@/components/Admin/User/Butler'),
              meta: {
                title: "管家管理"
              }
            },
            {
              path: 'Butleruser',
              name: "UserBulterRole",
              component: () => import('@/components/Admin/User/Butleruser'),
              meta: {
                title: "管家角色"
              }
            },

            {
              path: 'CustomerAdd',
              name: "CustomerAddIndex",
              component: () => import('@/components/Admin/User/CustomerManagement/CustomerAddIndex'),
              meta: {
                title: "入伙管理"
              }
            },
            {
              path: 'CustomerCheckin',
              name: "CustomerCheckinIndex",
              component: () => import('@/components/Admin/User/CustomerManagement/CustomerCheckinIndex'),
              meta: {
                title: "入住管理"
              }
            },
            {
              path: 'CustomerRent',
              name: "CustomerRentIndex",
              component: () => import('@/components/Admin/User/CustomerManagement/CustomerRentMaster'),
              meta: {
                title: "出租登记"
              }
            },
            {
              path: 'CustomerRentMasterIntention',
              name: "CustomerRentMasterIntention",
              component: () => import('@/components/Admin/User/CustomerManagement/CustomerRentMasterIntention'),
              meta: {
                title: "出租意向列表"
              }
            },
            {
              path: 'CustomerRentMasterPreview',
              name: "CustomerRentMasterPreview",
              component: () => import('@/components/Admin/User/CustomerManagement/CustomerRentMasterPreview'),
              meta: {
                title: "出租数据预览"
              }
            },
            {
              path: 'CustomerFurnish',
              name: "CustomerFurnishIndex",
              component: () => import('@/components/Admin/User/CustomerManagement/FurnishMaster'),
              meta: {
                title: "装修管理"
              }
            },
            {
              path: 'FurnishMasterPreview',
              name: "FurnishMasterPreview",
              component: () => import('@/components/Admin/User/CustomerManagement/FurnishMasterPreview'),
              meta: {
                title: "装修数据预览"
              }
            },
            {
              path: 'DecorationInspectionRecordForm',
              name: "DecorationInspectionRecordForm",
              component: () => import('@/components/Admin/User/CustomerManagement/DecorationInspectionRecordForm'),
              meta: {
                title: "装修巡查执行情况汇总表"
              }
            },
            {
              path: 'CustomerSale',
              name: "CustomerSale",
              component: () => import('@/components/Admin/User/CustomerManagement/CustomerSale'),
              meta: {
                title: "售楼登记"
              }
            },
          ],
        },

        // 客户管理
        {
          path: 'Customer',
          name: 'Customer',
          component: () => import('@/components/Admin/Customer/index'),
          children: [{
              path: '/',
              name: "CustomerList",
              component: () => import('@/components/Admin/Customer/list'),
              meta: {
                title: "业户信息"
              }
            },
            {
              path: 'customerList',
              component: () => import('@/components/Admin/Customer/list')
            },
            {
              path: 'ReportCustomer',
              meta: {
                title: "业户报表"
              },
              component: () => import('@/components/Admin/Customer/ReportCustomer')
            },
            {
              path: 'CustomerBinding',
              meta: {
                title: "未绑定客户房产"
              },
              component: () => import('@/components/Admin/Customer/customer_binding')
            },
            {
              path: 'CustomerHouseLog',
              meta: {
                title: "业户日志"
              },
              component: () => import('@/components/Admin/Customer/CustomerHouseLog')
            },
            {
              path: 'CustomerTempForm',
              meta: {
                title: "业户审批"
              },
              component: () => import('@/components/Admin/Customer/CustomerTempForm')
            },
          ],
        },
        {
          path: 'HouseCode',
          name: 'HouseCode',
          component: () => import('@/components/Admin/HouseCode/index'),
          children: [{
              path: '/',
              component: () => import('@/components/Admin/HouseCode/HouseCodeList')
            },
            {
              path: 'list',
              name: "HouseCodeList",
              component: () => import('@/components/Admin/HouseCode/HouseCodeList'),
              meta: {
                title: "一户一码"
              }
            },
            {
              path: 'HouseStatistics',
              name: "HouseStatistics",
              component: () => import('@/components/Admin/HouseCode/HouseStatistics'),
              meta: {
                title: "房态统计"
              }
            },
            {
              path: 'RoomStatus',
              name: "RoomStatus",
              component: () => import('@/components/Admin/HouseCode/RoomStatus'),
              meta: {
                title: "房态管理"
              }
            },
          ],
        },

        //财务
        {
          path: 'Finance',
          name: 'Finance',
          component: () => import('@/components/Admin/Finance/index'),
          children: [{
              path: 'invoice',
              name: "FinanceInvoice",
              component: () => import('@/components/Admin/Finance/invoice'),
              meta: {
                title: "发票管理"
              }
            },
            {
              path: 'invoiceDisc',
              name: "FinanceInvoiceDiscManage",
              component: () => import('@/components/Admin/Finance/invoiceDisc'),
              meta: {
                title: "税盘管理"
              }
            },
            {
              path : 'invoiceStatic',
              name : 'FinanceInvoiceStatic',
              component : () => import('@/components/Admin/Finance/invoiceStatic'),
              meta : {title : '发票统计'}
            },
            {
              path: 'taxplate',
              component: () => import('@/components/Admin/Finance/taxplate')
            },
            {
              path: 'bill',
              name: "FinanceBill",
              component: () => import('@/components/Admin/Finance/bill'),
              meta: {
                title: "票据打印列表"
              }
            },
            {
              path: 'target',
              name: "FinanceTarget",
              component: () => import('@/components/Admin/Order/FinanceTarget'),
              meta: {
                title: "指标设置"
              }
            },
            {
              path: 'targetAdjust',
              name: "FinanceTargetAdjust",
              component: () => import('@/components/Admin/Order/FinanceTargetAdjust'),
              meta: {
                title: "指标调整"
              }
            },
            {
              path: 'multipleAdjust',
              name: "MeterMultipleExcel",
              component: () => import('@/components/Admin/Project/MeterMultipleExcel'),
              meta: {
                title: "倍数指标"
              }
            },
            {
              path: 'amenityFee',
              name: "AmenityFee",
              component: () => import('@/components/Admin/AmenityFee/list'),
              meta: {
                title: "公设费管理"
              }
            },
            {
              path: 'amenityCharge',
              name: "AmenityCharge",
              component: () => import('@/components/Admin/AmenityFee/charge'),
              meta: {
                title: "公设费收缴"
              }
            },
            {
              path: 'amenityForm',
              name: "AmenityForm",
              component: () => import('@/components/Admin/AmenityFee/form'),
              meta: {
                title: "公设费收缴"
              }
            },
            {
              path: 'openingAmount',
              name: "OpeningAmount",
              component: () => import('@/components/Admin/Forms/openingAmount'),
              meta: {
                title: "期初管理"
              }
            },
          ],
        },


        //财务报表
        {
          path: 'Forms',
          name: 'Forms',
          component: () => import('@/components/Admin/Forms/index'),
          children: [
            // {
            //   path: '/',
            //   name: "FormsOrderList",
            //   component: () => import('@/components/Admin/Forms/orderList'),
            //   meta: {
            //     title: "财务报表"
            //   }
            // },
            {
              path: 'orderList',
              name: "FormsOrderList",
              component: () => import('@/components/Admin/Forms/orderList'),
              meta: {
                title: "财务报表"
              }
            },
            {
              path: 'receivables',
              name: "FormsReceivables",
              component: () => import('@/components/Admin/Forms/receivables'),
              meta: {
                title: "应收款明细表"
              }
            },
            {
              path: 'receivablesUpdate',
              name: "ReceivablesUpdate",
              component: () => import('@/components/Admin/Forms/receivablesUpdate'),
              meta: {
                title: "应收款变动明细表"
              }
            },
            {
              path: 'collectMoney',
              name: "FormsCollectMoney",
              component: () => import('@/components/Admin/Forms/collectMoney'),
              meta: {
                title: "收款明细表"
              }
            },
            {
              path: 'oweMoney',
              name: "FormsOweMoney",
              component: () => import('@/components/Admin/Forms/oweMoney'),
              meta: {
                title: "欠费账龄按户统计明细表"
              }
            },
            {
              path: 'oweCheck',
              name: "FormsOweCheck",
              component: () => import('@/components/Admin/Forms/oweCheck'),
              meta: {
                title: "系统欠费检、抽查记录表"
              }
            },
            {
              path: 'minusMoney',
              name: "FormsMinusMoney",
              component: () => import('@/components/Admin/Forms/minusMoney'),
              meta: {
                title: "费用减免汇总表（明细）"
              }
            },
            {
              path: 'advances',
              name: "FormsAdvances",
              component: () => import('@/components/Admin/Forms/advances'),
              meta: {
                title: "客户预收款余额明细表"
              }
            },
            {
              path: 'advancesUpdate',
              component: () => import('@/components/Admin/Forms/advancesUpdate')
            },
            {
              path: 'deposit',
              name: "FormsDeposit",
              component: () => import('@/components/Admin/Forms/deposit'),
              meta: {
                title: "客户押金余额明细表"
              }
            },
            {
              path: 'depositUpdate',
              name: "DepositUpdate",
              component: () => import('@/components/Admin/Forms/depositUpdate'),
              meta: {
                title: "客户押金变动明细表"
              }
            },
            {
              path: 'chargeSum',
              name: "FormsChargeSum",
              component: () => import('@/components/Admin/Forms/chargeSum'),
              meta: {
                title: "收费汇总表"
              }
            },
            {
              path: 'chargeDetail',
              name: "FormsChargeDetail",
              component: () => import('@/components/Admin/Forms/chargeDetail'),
              meta: {
                title: "收费明细（汇总）表"
              }
            },
            {
              path: 'advancesDetail',
              name: "FormsAdvancesDetail",
              component: () => import('@/components/Admin/Forms/advancesDetail'),
              meta: {
                title: "预收账款汇总表"
              }
            },
            {
              path: 'noticeOfPayment',
              name: "NoticeOfPayment",
              component: () => import('@/components/Admin/Forms/noticeOfPayment'),
              meta: {
                title: "缴费通知单"
              }
            },
            {
              path: 'depositSummarySheet',
              name: "DepositSummarySheet",
              component: () => import('@/components/Admin/Forms/depositSummarySheet'),
              meta: {
                title: "押金汇总表"
              }
            },
            {
              path: 'advanceList',
              name: "AdvanceList",
              component: () => import('@/components/Admin/Forms/advanceList'),
              meta: {
                title: "客户预收款变动明细表"
              }
            },
            {
              path: 'advancesCollect',
              name: "AdvancesCollect",
              component: () => import('@/components/Admin/Forms/advancesCollect'),
              meta: {
                title: "预收款汇总表"
              }
            },
            {
              path: 'advancesCollect',
              name: "AdvancesCollect",
              component: () => import('@/components/Admin/Forms/advancesCollect'),
              meta: {
                title: "预收款汇总表"
              }
            },
            {
              path: 'financialAgeAnalysisStatement',
              name: "FinancialAgeAnalysisStatement",
              component: () => import('@/components/Admin/Forms/financialAgeAnalysisStatement'),
              meta: {
                title: "欠费账龄绩效统计表"
              }
            },
            {
              path: 'historyFinancialAge',
              name: "HistoryFinancialAge",
              component: () => import('@/components/Admin/Forms/historyFinancialAge'),
              meta: {
                title: "历史账龄收缴率报表"
              }
            },
            {
              path: 'withdrawFinancial',
              name: "WthdrawFinancial",
              component: () => import('@/components/Admin/Forms/withdrawFinancial'),
              meta: {
                title: "撤场项目收费统计表"
              }
            },
            {
              path: 'paymentRateStatement',
              name: "PaymentRateStatement",
              component: () => import('@/components/Admin/Forms/paymentRateStatement'),
              meta: {
                title: "在管项目收缴率统计报表"
              }
            },
            {
              path: 'dailyStatement',
              name: "DailyStatement",
              component: () => import('@/components/Admin/Forms/dailyStatement'),
              meta: {
                title: "现金流收支情况日报表"
              }
            },
            {
              path: 'AgingStatistics',
              name: "AgingStatistics",
              component: () => import('@/components/Admin/Forms/AgingStatistics'),
              meta: {
                title: "账龄分析"
              }
            },
            {
              path: 'projectDeductions',
              name: "ProjectDeductions",
              component: () => import('@/components/Admin/Forms/projectDeductions'),
              meta: {
                title: "项目减免汇总表"
              }
            },
            {
              path: 'auditReport',
              name: "AuditReport",
              component: () => import('@/components/Admin/Forms/AuditReport'),
              meta: {
                title: "审计口径历史欠费余额变动表"
              }
            },
            {
              path: 'reductionsAdjustments',
              name: "ReductionsAdjustments",
              component: () => import('@/components/Admin/Forms/reductionsAdjustments'),
              meta: {
                title: "系统减免及调整汇总表"
              }
            },
          ],
        },


        //App应用
        {
          path: 'App',
          name: 'AppIndex',
          component: () => import('@/components/Admin/App/Index'),
          meta: {
            title: "应用"
          }
        },

        //App应用（报事报修）
        {
          path: 'Repair',
          name: 'RepairIndex',
          component: () => import('@/components/Admin/App/Repair/Index'),
          children: [{
              path: '/',
              name: "Repairs",
              component: () => import('@/components/Admin/App/Repair/Repairs'),
              meta: {
                title: "报事报修"
              }
            },
            {
              path: 'repairs',
              name: "Repairs",
              component: () => import('@/components/Admin/App/Repair/Repairs'),
              meta: {
                title: "报事报修"
              }
            },
            {
              path: 'rwarning',
              name: "RepairRwarning",
              component: () => import('@/components/Admin/App/Repair/Rwarning'),
              meta: {
                title: "预警设置"
              }
            },
            {
              path: 'hangUpRepair',
              name: "HangUpRepair",
              component: () => import('@/components/Admin/App/Repair/HangUpRepair'),
              meta: {
                title: "暂挂审核"
              }
            },
          ],
          meta: {
            title: "报事报修"
          }
        },
        //App应用（投诉处理）
        {
          path: 'Complaint',
          name: 'ComplaintIndex',
          component: () => import('@/components/Admin/App/Complaint/Index'),
          children: [{
              path: '/',
              name: "Complaints",
              component: () => import('@/components/Admin/App/Complaint/Complaint'),
              meta: {
                title: "投诉建议"
              }
            },
            {
              path: 'complaints',
              name: "Complaints",
              component: () => import('@/components/Admin/App/Complaint/Complaint'),
              meta: {
                title: "投诉建议"
              }
            },
            {
              path: 'cwarning',
              name: "ComplaintWarning",
              component: () => import('@/components/Admin/App/Complaint/Cwarning'),
              meta: {
                title: "预警设置"
              }
            },
            {
              path: 'cpending',
              name: "ComplaintPending",
              component: () => import('@/components/Admin/App/Complaint/Cpending'),
              meta: {
                title: "暂挂审核"
              }
            },
          ],
          meta: {
            title: "投诉处理"
          }
        },
        //App应用（咨询管理）
        {
          path: 'Consult',
          name: 'ConsultIndex',
          component: () => import('@/components/Admin/App/Consult/Index'),
          children: [{
              path: '/',
              name: "Consult",
              component: () => import('@/components/Admin/App/Consult/Consult'),
              meta: {
                title: "咨询管理"
              }
            },
            {
              path: 'consult',
              name: "Consult",
              component: () => import('@/components/Admin/App/Consult/Consult'),
              meta: {
                title: "咨询管理"
              }
            },
            {
              path: 'cowarning',
              name: "ConsultWarning",
              component: () => import('@/components/Admin/App/Consult/Cowarning'),
              meta: {
                title: "暂挂审核"
              }
            },
            {
              path: 'coending',
              name: "ConsultPending",
              component: () => import('@/components/Admin/App/Consult/Coending'),
              meta: {
                title: "预警设置"
              }
            },
          ],
          meta: {
            title: "咨询管理"
          }
        },

        //App应用（舆情，会话）
        {
          path: 'Conversation',
          name: 'ConversationIndex',
          component: () => import('@/components/Admin/App/Conversation/Index'),
          children: [{
              path: '/',
              name: "ConversationChat",
              component: () => import('@/components/Admin/App/Conversation/Chat'),
              meta: {
                title: "会话管理"
              }
            },
            {
              path: 'Chat',
              name: "ConversationChat",
              component: () => import('@/components/Admin/App/Conversation/Chat'),
              meta: {
                title: "会话管理"
              }
            },
            {
              path: 'Keyword',
              name: "ConversationKeyword",
              component: () => import('@/components/Admin/App/Conversation/Keyword'),
              meta: {
                title: "关键字管理"
              }
            },
            {
              path: 'GroupChat',
              name: "ConversationGroupChat",
              component: () => import('@/components/Admin/App/Conversation/GroupChat'),
              meta: {
                title: "群管理"
              }
            },
            {
              path: 'Overview',
              name: "ConversationOverview",
              component: () => import('@/components/Admin/App/Conversation/Overview'),
              meta: {
                title: "社群总览"
              }
            },
            {
              path: 'ProjectActive',
              name: "ConversationProjectActive",
              component: () => import('@/components/Admin/App/Conversation/ProjectActive'),
              meta: {
                title: "项目活跃分析"
              }
            },
            {
              path: 'ProjectFocus',
              name: "ConversationProjectFocus",
              component: () => import('@/components/Admin/App/Conversation/ProjectFocus'),
              meta: {
                title: "项目关注重点"
              }
            },
            {
              path: 'ProjectCrisis',
              name: "ConversationProjectCrisis",
              component: () => import('@/components/Admin/App/Conversation/ProjectCrisis'),
              meta: {
                title: "项目危机排名"
              }
            },
            {
              path: 'GroupActive',
              name: "ConversationGroupActive",
              component: () => import('@/components/Admin/App/Conversation/GroupActive'),
              meta: {
                title: "群活跃分析"
              }
            },
            {
              path: 'GroupFocus',
              name: "ConversationGroupFocus",
              component: () => import('@/components/Admin/App/Conversation/GroupFocus'),
              meta: {
                title: "群关注重点"
              }
            },
            {
              path: 'GroupCrisis',
              name: "ConversationGroupCrisis",
              component: () => import('@/components/Admin/App/Conversation/GroupCrisis'),
              meta: {
                title: "群危机排名"
              }
            },
            {
              path: 'MemberAnalyze',
              name: "ConversationMemberAnalyze",
              component: () => import('@/components/Admin/App/Conversation/MemberAnalyze'),
              meta: {
                title: "群成员分析"
              }
            },
          ],
          meta: {
            title: "舆情会话"
          }
        },

        //App应用（名贴）
        {
          path: 'Card',
          name: 'CardIndex',
          component: () => import('@/components/Admin/App/Card/Index'),
          children: [{
              path: '/',
              name: "CardUser",
              component: () => import('@/components/Admin/App/Card/User'),
              meta: {
                title: "会员管理"
              }
            },
            {
              path: 'User',
              name: "CardUser",
              component: () => import('@/components/Admin/App/Card/User'),
              meta: {
                title: "会员管理"
              }
            },
            {
              path: 'Card',
              name: "CardCard",
              component: () => import('@/components/Admin/App/Card/Card'),
              meta: {
                title: "名片管理"
              }
            },
            {
              path: 'Article',
              name: "CardArticle",
              component: () => import('@/components/Admin/App/Card/Article'),
              meta: {
                title: "内容管理"
              }
            },
            {
              path: 'UserGroup',
              name: "CardUserGroup",
              component: () => import('@/components/Admin/App/Card/UserGroup'),
              meta: {
                title: "分组管理"
              }
            },
            {
              path: 'CardBackground',
              name: "CardBackground",
              component: () => import('@/components/Admin/App/Card/CardBackground'),
              meta: {
                title: "背景管理"
              }
            },
            {
              path: 'CardStyle',
              name: "CardStyle",
              component: () => import('@/components/Admin/App/Card/CardStyle'),
              meta: {
                title: "主题设置"
              }
            },
            {
              path: 'CardPoster',
              name: "CardPoster",
              component: () => import('@/components/Admin/App/Card/CardPoster'),
              meta: {
                title: "海报管理"
              }
            },
            {
              path: 'Config',
              name: "CardConfig",
              component: () => import('@/components/Admin/App/Card/Config'),
              meta: {
                title: "配置管理"
              }
            },
            {
              path: 'Industry',
              name: "CardIndustry",
              component: () => import('@/components/Admin/App/Card/Industry'),
              meta: {
                title: "行业管理"
              }
            },
            {
              path: 'DepartmentConfig',
              name: "DepartmentConfig",
              component: () => import('@/components/Admin/App/Card/DepartmentConfig'),
              meta: {
                title: "部门配置"
              }
            },
          ],
          meta: {
            title: "电子名贴"
          }
        },

        //OA
        {
          path: 'Oa',
          name: 'Oa',
          component: () => import('@/components/Admin/Oa/index'),
          children: [
            // {
            //   path: '/',
            //   name: "CheckWorkAdmin",
            //   component: () => import('@/components/Admin/Oa/CheckWorkAdmin'),
            //   meta: {
            //     title: "管理员列表"
            //   }
            // },
            {
              path: 'CheckWorkAdmin',
              name: "CheckWorkAdmin",
              component: () => import('@/components/Admin/Oa/CheckWorkAdmin'),
              meta: {
                title: "管理员列表"
              }
            },
            {
              path: 'CheckWorkUser',
              name: "CheckWorkUser",
              component: () => import('@/components/Admin/Oa/CheckWorkUser'),
              meta: {
                title: "员工列表"
              }
            },
            {
              path: 'CheckWorkUserClass',
              name: "CheckWorkUserClass",
              component: () => import('@/components/Admin/Oa/CheckWorkUserClass'),
              meta: {
                title: "排班列表"
              }
            },
            {
              path: 'OAIndex',
              name: "OAIndex",
              component: () => import('@/components/Admin/Oa/OAIndex'),
              meta: {
                title: "功能列表"
              }
            },
            {
              path: 'AppChannel',
              name: "AppChannel",
              component: () => import('@/components/Admin/Oa/AppChannel'),
              meta: {
                title: "栏目列表"
              }
            },
            {
              path: 'UserManage',
              name: "UserManage",
              component: () => import('@/components/Admin/Oa/UserManage'),
              meta: {
                title: "人员管理"
              }
            },
            {
              path: 'PreUserManage',
              name: "PreUserManage",
              component: () => import('@/components/Admin/Oa/PreUserManage'),
              meta: {
                title: "人员管理"
              }
            },
            {
              path: 'PreJobManage',
              name: "PreJobManage",
              component: () => import('@/components/Admin/Oa/PreJobManage'),
              meta: {
                title: "职位管理"
              }
            },
            // {
            //   path: 'PreSocialSecurity',
            //   name: "PreSocialSecurity",
            //   component: () => import('@/components/Admin/Oa/PreSocialSecurity'),
            //   meta: {
            //     title: "社保管理管理"
            //   }
            // },
            {
              path: 'PreSalary',
              name: "PreSalary",
              component: () => import('@/components/Admin/Oa/PreSalary'),
              meta: {
                title: "薪资管理"
              }
            },
            {
              path: 'PreSalaryOrigin',
              name: "PreSalaryOrigin",
              component: () => import('@/components/Admin/Oa/PreSalaryOrigin'),
              meta: {
                title: "申报工资管理"
              }
            },
            {
              path: 'AttendanceList',
              name: "AttendanceList",
              component: () => import('@/components/Admin/Oa/Attendance/list'),
              meta: {
                title: "考勤列表"
              }
            },
            {
              path: 'RewardList',
              name: "RewardList",
              component: () => import('@/components/Admin/Oa/Attendance/rewardList'),
              meta: {
                title: "奖惩记录"
              }
            },
            {
              path: 'RewardView',
              name: "RewardView",
              component: () => import('@/components/Admin/Oa/Attendance/rewardView'),
              meta: {
                title: "奖惩情况"
              }
            },
            {
              path: 'SalaryOrigin',
              name: "SalaryOrigin",
              component: () => import('@/components/Admin/Oa/PreSalary/SalaryOrigin'),
              meta: {
                title: "薪资列表"
              }
            },
            {
              path: 'EditSalaryOrigin',
              name: "EditSalaryOrigin",
              component: () => import('@/components/Admin/Oa/PreSalary/EditSalaryOrigin'),
              meta: {
                title: "薪资列表"
              }
            },
            {
              path: 'SocialSecurityList',
              name: "SocialSecurityList",
              component: () => import('@/components/Admin/Oa/PreSalary/SocialSecurityList'),
              meta: {
                title: "社保管理"
              }
            },
            {
              path: 'RequiredAttendanceList',
              name: "RequiredAttendanceList",
              component: () => import('@/components/Admin/Oa/Attendance/RequiredAttendanceList'),
              meta: {
                title: "应出勤管理"
              }
            },
            {
              path: 'SchedulingList',
              name: "SchedulingList",
              component: () => import('@/components/Admin/Oa/Scheduling/List'),
              meta: {
                title: "出勤和加班管理"
              }
            },
            {
              path: 'RoleList',
              name: "RoleList",
              component: () => import('@/components/Admin/Oa/PreUser/RoleList'),
              meta: {
                title: "权限管理"
              }
            },
            {
              path: 'ProjectConfigList',
              name: "ProjectConfigList",
              component: () => import('@/components/Admin/Oa/PreUser/ProjectConfigList'),
              meta: {
                title: "项目基数设置"
              }
            },
            {
              path: 'FlowConfingList',
              name: "FlowConfingList",
              component: () => import('@/components/Admin/Oa/PreUser/FlowConfingList'),
              meta: {
                title: "流程配置"
              }
            },
            {
              path: 'EnvironmentalList',
              name: "EnvironmentalList",
              component: () => import('@/components/Admin/Oa/Environmental/List'),
              meta: {
                title: "环卫数据导出"
              }
            },
          ],
          meta: {
            title: "智慧办公"
          }
        },

        {
          path: 'ManagerMeter',
          name: 'ManagerMeter',
          component: () => import('@/components/Admin/ManagerMeter/index'),
          children: [{
              path: 'Meter',
              name: "Meter",
              component: () => import('@/components/Admin/ManagerMeter/Meter'),
              meta: {
                title: "仪表登记"
              }
            },
            {
              path: 'MeterNote',
              name: "MeterNote",
              component: () => import('@/components/Admin/ManagerMeter/MeterNote'),
              meta: {
                title: "仪表抄表"
              }
            },
            {
              path: 'MeterExcel',
              component: () => import('@/components/Admin/ManagerMeter/MeterExcel'),
              meta: {
                title: '仪表导入/导出'
              }
            },
            {
              path: 'MeterNoteDetail',
              name: "MeterNoteDetail",
              component: () => import('@/components/Admin/ManagerMeter/MeterNoteDetail'),
              meta: {
                title: "仪表抄表明细"
              }
            },
          ],
          meta: {
            title: "仪表管理"
          }
        },
        {
          path: 'SecpMeter',
          name: 'SecpMeter',
          component: () => import('@/components/Admin/SecpMeter/index'),
          children: [{
              path: 'Meter',
              name: "Meter",
              component: () => import('@/components/Admin/SecpMeter/Meter'),
              meta: {
                title: "仪表登记"
              }
            },
            {
              path: 'MeterNote',
              name: "MeterNote",
              component: () => import('@/components/Admin/SecpMeter/MeterNote'),
              meta: {
                title: "仪表抄表"
              }
            },
            {
              path: 'MeterExcel',
              component: () => import('@/components/Admin/SecpMeter/MeterExcel'),
              meta: {
                title: '仪表导入/导出'
              }
            },
            {
              path: 'LineStructure',
              component: () => import('@/components/Admin/SecpMeter/LineStructure'),
              meta: {
                title: '仪表线路'
              }
            },
            {
              path: 'MeterNoteDetail',
              name: "MeterNoteDetail",
              component: () => import('@/components/Admin/SecpMeter/MeterNoteDetail'),
              meta: {
                title: "仪表抄表明细"
              }
            },
          ],
          meta: {
            title: "仪表管理"
          }
        },

        //小程序
        {
          path: 'Applets',
          name: 'AppletsIndex',
          component: () => import('@/components/Admin/Applets/index'),
          children: [
            // {
            //   path: '/',
            //   name: "AppletsList",
            //   component: () => import('@/components/Admin/Applets/appletslist'),
            //   meta: {
            //     title: "小程序管理"
            //   }
            // },
            {
              path: 'appletslist',
              name: "AppletsList",
              component: () => import('@/components/Admin/Applets/appletslist'),
              meta: {
                title: "小程序管理"
              }
            },
            {
              path: 'appletsclass',
              name: "AppletsClass",
              component: () => import('@/components/Admin/Applets/appletsclass'),
              meta: {
                title: "支付配置"
              }
            },
            {
              path: 'appletsHome',
              name: "AppletsHome",
              component: () => import('@/components/Admin/Applets/appletsHome'),
              meta: {
                title: "首页装修"
              }
            },
            {
              path: 'appletsFitUp',
              name: "appletsFitUp",
              component: () => import('@/components/Admin/Applets/appletsFitUp')
            },
            {
              path: 'appletsPay',
              name: "appletsPay",
              component: () => import('@/components/Admin/Applets/appletsPay')
            },
          ],
        },

        // 架构
        {
          path: 'Jindex',
          name: 'Jindex',
          component: () => import('@/components/Admin/Jurisdiction/Jindex'),
          children: [
            // {
            //   path: '/',
            //   name: "JindexAdd",
            //   component: () => import('@/components/Admin/Jurisdiction/JindexAdd'),
            //   meta: {
            //     title: "架构管理"
            //   }
            // },
            {
              path: 'JAdd',
              name: 'JAdd',
              component: () => import('@/components/Admin/Jurisdiction/JAdd'),
              meta: {
                title: "组织管理"
              }
            },
            {
              path: 'JindexAdd',
              name: "JindexAdd",
              component: () => import('@/components/Admin/Jurisdiction/JindexAdd'),
              meta: {
                title: "架构管理"
              }
            },
            {
              path: 'JindexAdds',
              name: "JindexAdds",
              component: () => import('@/components/Admin/Jurisdiction/JindexAdds'),
              meta: {
                title: "部门管理"
              }
            },
            {
              path: 'JuserindexAdd',
              name: "JuserindexAdd",
              component: () => import('@/components/Admin/Jurisdiction/JuserindexAdd'),
              meta: {
                title: "人员管理"
              }
            },
            {
              path: 'Jlist',
              name: "Jlist",
              component: () => import('@/components/Admin/Jurisdiction/Jlist'),
              meta: {
                title: "架构列表"
              }
            },
            {
              path: 'MenuTree',
              name: "MenuTree",
              component: () => import('@/components/Admin/Config/MenuTree'),
              meta: {
                title: "菜单管理"
              }
            },
          ],
          meta: {
            title: "架构"
          }
        },

        //  设置配置
        {
          path: 'Config',
          name: 'ConfigIndex',
          component: () => import('@/components/Admin/Config/index'),
          children: [{
              path: 'Config',
              name: "ConfigConfig",
              component: () => import('@/components/Admin/Config/Config'),
              meta: {
                title: "基础设置"
              }
            },
            {
              path: 'CreateTreeMenu',
              name: "CreateTreeMenu",
              component: () => import('@/components/Admin/Config/CreateTreeMenu'),
              meta: {
                title: "生成目录"
              }
            },
            {
              path: 'RoleSetting',
              name: "RoleSetting",
              component: () => import('@/components/Admin/Config/Role/RoleList'),
              meta: {
                title: "角色权限配置"
              }
            },
            {
              path: 'OperatorSetting',
              name: "OperatorSetting",
              component: () => import('@/components/Admin/Config/Operator/OperatorList'),
              meta: {
                title: "操作员设置"
              }
            },
            {
              path: 'ErpTreeUpdateStatus',
              name: "ErpTreeUpdateStatus",
              component: () => import('@/components/Admin/Common/ErpTreeUpdateStatus'),
              meta: {
                title: "房产排序"
              }
            },
          ],
          meta: {
            title: "设置"
          }
        },

        //合同管理
        {
          path: 'Contract',
          name: 'ContractIndex',
          component: () => import('@/components/Admin/Contract/index'),
          children: [{
              path: '/Contract/',
              name: "Contract",
              component: () => import('@/components/Admin/Contract/Contract'),
              meta: {
                title: "合同登记"
              }
            },
            {
              path: '/Contract/Area',
              name: "ContractArea",
              component: () => import('@/components/Admin/Contract/Area'),
              meta: {
                title: "组织架构"
              }
            },
            {
              path: '/Contract/Business',
              name: "ContractBusiness",
              component: () => import('@/components/Admin/Contract/Business'),
              meta: {
                title: "业务类型"
              }
            },
            {
              path: '/Contract/Partnership',
              name: "ContractPartnership",
              component: () => import('@/components/Admin/Contract/Partnership'),
              meta: {
                title: "合作伙伴"
              }
            },
            {
              path: '/Contract/ContractProject',
              name: "ContractProject",
              component: () => import('@/components/Admin/Contract/ContractProject'),
              meta: {
                title: "项目管理"
              }
            },
            {
              path: '/Contract/ContractFinance',
              name: "ContractFinance",
              component: () => import('@/components/Admin/Contract/ContractFinance'),
              meta: {
                title: "变动登记"
              }
            },
            {
              path: '/Contract/ContractFinanceInvoice',
              name: "ContractFinanceInvoice",
              component: () => import('@/components/Admin/Contract/ContractFinanceInvoice'),
              meta: {
                title: "开票登记"
              }
            },
            {
              path: '/Contract/ContractFinanceIncome',
              name: "ContractFinanceIncome",
              component: () => import('@/components/Admin/Contract/ContractFinanceIncome'),
              meta: {
                title: "收款登记"
              }
            },
            {
              path: '/Contract/ContractFinanceArrears',
              name: "ContractFinanceArrears",
              component: () => import('@/components/Admin/Contract/ContractFinanceArrears'),
              meta: {
                title: "收款记录"
              }
            },
            {
              path: '/Contract/FinancialManagement',
              name: "ContractFinancialManagement",
              component: () => import('@/components/Admin/Contract/ContractFinancialManagement'),
              meta: {
                title: "报表管理"
              }
            },
            {
              path: '/Contract/ReceivedAccount',
              name: "ReceivedAccount",
              component: () => import('@/components/Admin/Contract/ReceivedAccount'),
              meta: {
                title: "已收款台账"
              }
            },
            {
              path: '/Contract/InvoiceUncollected',
              name: "InvoiceUncollected",
              component: () => import('@/components/Admin/Contract/InvoiceUncollected'),
              meta: {
                title: "开票末回款"
              }
            },
            {
              path: '/Contract/Receivables',
              name: "Receivables",
              component: () => import('@/components/Admin/Contract/Receivables'),
              meta: {
                title: "权责收入台账"
              }
            },
            {
              path: '/Contract/ArrearageAging',
              name: "ArrearageAging",
              component: () => import('@/components/Admin/Contract/ArrearageAging'),
              meta: {
                title: "欠费账龄表"
              }
            },
            {
              path: '/Contract/Receivables2',
              component: () => import('@/components/Admin/Contract/Receivables2'),
              meta: {
                title: "应收款台账"
              }
            },
            {
              path: '/Contract/ContractLedger',
              component: () => import('@/components/Admin/Contract/ContractLedger'),
              meta: {
                title: "合同台账"
              }
            },
            {
              path: '/Contract/Statics',
              component: () => import('@/components/Admin/Contract/Statics'),
              meta: {
                title: "月结报表"
              }
            },
            {
              path : '/Contract/ContractPlan',
              component : () => import('@/components/Admin/Contract/ContractPlan'),
              meta : {
                title : "收款计划"
              }
            },
            {
              path :'/Contract/RightReport' ,
              component : () => import('@/components/Admin/Contract/RightReport'),
              meta : { title : '权责报表录入'}
            },
            {
              path : '/Contract/RightReportTable' ,
              component :() => import('@/components/Admin/Contract/RightReportTable') ,
              meta : {title : '权责报表'}
            }
          ],
          meta: {
            title: "合同管理"
          }
        },
        //合同管理
        {
          path: 'Cms',
          name: 'Cms',
          component: () => import('@/components/Admin/Cms/index'),
          children: [{
              path: '/Cms/',
              component: () => import('@/components/Admin/Cms/CmsArticle')
            },
            {
              path: '/Cms/CmsArticle',
              component: () => import('@/components/Admin/Cms/CmsArticle')
            },
            {
              path: '/Cms/CmsChannel',
              component: () => import('@/components/Admin/Cms/CmsChannel')
            },
          ],
        },
        //人事管理
        {
          path: 'Personnel',
          name: 'ContractIndex',
          component: () => import('@/components/Admin/Contract/index'),
          children: [{
              path: '/Personnel/addressList',
              name: "PersonnelAddressList",
              component: () => import('@/components/Admin/Personnel/addressList'),
              meta: {
                title: "通讯录"
              }
            },
            // {
            //   path: '/Personnel/addressList2',
            //   name: "PersonnelAddressList2",
            //   component: () => import('@/components/Admin/Personnel/addressList2'),
            //   meta: {
            //     title: "通讯录2"
            //   }
            // },

          ],
          meta: {
            title: "人事管理"
          }
        },
        {
          path: 'financialChart',
          name: 'financialChartIndex',
          component: () => import('@/components/Admin/FinancialChart/index'),
          children: [{
            path: 'index',
            name: "financialChartIndex",
            component: () => import('@/components/Admin/FinancialChart/index'),
            meta: {
              title: "财务图表"
            }
          }]
        },
        {
          path: 'Butler',
          name: 'Butler',
          component: () => import('@/components/Admin/Butler/index'),
          children: [{
              path: '/',
              component: () => import('@/components/Admin/Butler/Legal')
            },
            {
              path: 'Legal',
              name: "Legal",
              component: () => import('@/components/Admin/Butler/Legal'),
              meta: {
                title: "催缴记录"
              }
            },
            {
              path: 'LegalStatisticsView',
              name: "LegalStatisticsView",
              component: () => import('@/components/Admin/Butler/LegalStatisticsView'),
              meta: {
                title: "催缴统计"
              }
            },
            {
              path: 'PropertyCertificationList',
              name: "PropertyCertificationList",
              component: () => import('@/components/Admin/Butler/PropertyCertificationList'),
              meta: {
                title: "认证明细"
              }
            },
            {
              path: 'PropertyCertificationStatistics',
              name: "PropertyCertificationStatistics",
              component: () => import('@/components/Admin/Butler/PropertyCertificationStatistics'),
              meta: {
                title: "认证统计"
              }
            },
            {
              path: 'ProjectAccount',
              name: "ProjectAccount",
              component: () => import('@/components/Admin/Butler/ProjectAccount'),
              meta: {
                title: "项目账号"
              }
            },
            {
              path: 'Litigation',
              name: "Litigation",
              component: () => import('@/components/Admin/Butler/Litigation'),
              meta: {
                title: "项目诉讼"
              }
            },
            {
              path: 'ExpeditingFeesPlan',
              name: "ExpeditingFeesPlan",
              component: () => import('@/components/Admin/Butler/ExpeditingFeesPlan'),
              meta: {
                title: "计划催费"
              }
            },
            {
              path: 'ThirdPartyLegal',
              name: "ThirdPartyLegal",
              component: () => import('@/components/Admin/Butler/ThirdPartyLegal'),
              meta: {
                title: "第三方管理"
              }
            },
            {
              path: 'LitigationStatistics',
              name: "LitigationStatistics",
              component: () => import('@/components/Admin/Butler/LitigationStatistics'),
              meta: {
                title: "诉讼统计"
              }
            },
            {
              path: 'ThirdPartyLegalStatistics',
              name: "ThirdPartyLegalStatistics",
              component: () => import('@/components/Admin/Butler/ThirdPartyLegalStatistics'),
              meta: {
                title: "第三方统计"
              }
            },
            {
              path: 'ReportLegal',
              name: "ReportLegal",
              component: () => import('@/components/Admin/Butler/ReportLegal'),
              meta: {
                title: "报表中心"
              }
            },
            {
              path: 'LegalSms',
              name: "LegalSms",
              component: () => import('@/components/Admin/Butler/LegalSms'),
              meta: {
                title: "短信催费"
              }
            },
            {
              path: 'TaskCount',
              name: "TaskCount",
              component: () => import('@/components/Admin/Butler/TaskCount'),
              meta: {
                title: "抽检记录"
              }
            },
            {
              path: 'TaskUserConfig',
              name: "TaskUserConfig",
              component: () => import('@/components/Admin/Butler/TaskUserConfig'),
              meta: {
                title: "抽检配置"
              }
            },
            {
              path: 'Sms',
              name: 'Sms',
              component: () => import('@/components/Admin/Butler/Sms'),
              meta: {
                title: "短信收发"
              }
            },
            {
              path: 'SmsTemplate',
              name: 'SmsTemplate',
              component: () => import('@/components/Admin/Butler/SmsTemplate'),
              meta: {
                title: "短信模版"
              }
            },
            {
              path: 'SmsUser',
              name: 'SmsUser',
              component: () => import('@/components/Admin/Butler/SmsUser'),
              meta: {
                title: "员工短信管理"
              }
            },
            {
              path: 'SmsSensitiveWord',
              name: 'SmsSensitiveWord',
              component: () => import('@/components/Admin/Butler/SmsSensitiveWord'),
              meta: {
                title: "短信敏感词管理"
              }
            },
            {
              path: 'SmsRemain',
              name: 'SmsRemain',
              component: () => import('@/components/Admin/Butler/SmsRemain'),
              meta: {
                title: "短信余额提醒"
              }
            },
            {
              path: 'AnnualLitigationPlanForProjectsUnderManagement',
              name: "AnnualLitigationPlanForProjectsUnderManagement",
              component: () => import('@/components/Admin/Butler/components/litigation/AnnualLitigationPlanForProjectsUnderManagement'),
              meta: {
                title: "年度诉讼计划"
              }
            },
            {
              path: 'CaseFilingRateAndPaymentCollectionStatistics',
              name: "CaseFilingRateAndPaymentCollectionStatistics",
              component: () => import('@/components/Admin/Butler/components/litigation/CaseFilingRateAndPaymentCollectionStatistics'),
              meta: {
                title: "立案率及回款统计"
              }
            },
            {
              path: 'ThirdPartyLitigation',
              name: "ThirdPartyLitigation",
              component: () => import('@/components/Admin/Butler/ThirdPartyLitigation'),
              meta: {
                title: "第三方诉讼"
              }
            },
            {
              path: 'LawsuitOverview',
              name: "LawsuitOverview",
              component: () => import('@/components/Admin/Butler/LawsuitOverview'),
              meta: {
                title: "诉讼概览"
              }
            },
            {
              path: 'Withdraw',
              name: "Withdraw",
              component: () => import('@/components/Admin/Butler/Withdraw'),
              meta: {
                title: "提现管理"
              }
            },
            {
              path: 'LegalLitigation',
              name: "LegalLitigation",
              component: () => import('@/components/Admin/Butler/LegalLitigation'),
              meta: {
                title: "项目自催"
              }
            },
          ],
        },
        {
          path: 'Log',
          name: 'Log',
          component: () => import('@/components/Admin/Log/index'),
          meta: {
            title: "系统日志"
          },
          children: [{
              path: '/',
              component: () => import('@/components/Admin/Log/LogList'),
              meta: {
                title: "前端操作日志"
              }
            },
            {
              path: 'LogList',
              name: "LogList",
              component: () => import('@/components/Admin/Log/LogList'),
              meta: {
                title: "前端操作日志"
              }
            },
          ],
        },
        {
          path: 'EnergyConsumption',
          name: 'EnergyConsumption',
          component: () => import('@/components/Admin/EnergyConsumption/index'),
          children: [{
              path: '/',
              name: "meter",
              component: () => import('@/components/Admin/EnergyConsumption/Meter'),
              meta: {
                title: "仪表登记"
              }
            },
            {
              path: 'meter',
              name: "meter",
              component: () => import('@/components/Admin/EnergyConsumption/Meter'),
              meta: {
                title: "仪表登记"
              }
            },
            {
              path: 'meterNote',
              name: "meterNote",
              component: () => import('@/components/Admin/EnergyConsumption/MeterNote'),
              meta: {
                title: "仪表抄表"
              }
            },
          ]
        },
        {
          path: 'MeterVirtually',
          name: 'MeterVirtually',
          component: () => import('@/components/Admin/MeterVirtually/index'),
          children: [{
              path: '/',
              name: "Virtually",
              component: () => import('@/components/Admin/MeterVirtually/Virtually'),
              meta: {
                title: "分摊表"
              }
            },
            {
              path: 'Virtually',
              name: "Virtually",
              component: () => import('@/components/Admin/MeterVirtually/Virtually'),
              meta: {
                title: "分摊表"
              }
            },
          ]
        },
        ...wujie.routes
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/login'),
    },
    {
      path: '/show',
      name: 'show',
      component: () => import('@/components/Show'),
      children: [{
          path: 'MeterViewCache',
          name: 'MeterViewCache',
          component: () => import('@/components/Admin/Meter/MeterViewCache'),
          meta: {
            title: "仪表审核"
          }
        },
        {
          path: 'MeterNoteViewCache',
          name: 'MeterNoteViewCache',
          component: () => import('@/components/Admin/Meter/MeterNoteViewCache'),
          meta: {
            title: "抄表审核"
          }
        },
        {
          path: 'LitigationTab4',
          name: 'LitigationTab4',
          component: () => import('@/components/Admin/Butler/components/litigation/LitigationTab4'),
          meta: {
            title: "诉讼审核"
          }
        },
        {
          path: 'ThirdPartyLegalPlanFlow',
          name: 'ThirdPartyLegalPlanFlow',
          component: () => import('@/components/Admin/Butler/components/plan/ThirdPartyLegalPlanFlow'),
          meta: {
            title: "第三方审核"
          }
        },
        {
          path: 'ThirdPartyTab4',
          name: 'ThirdPartyTab4',
          component: () => import('@/components/Admin/Butler/components/thirdparty/ThirdPartyTab4'),
          meta: {
            title: "第三方登记审核"
          }
        },
        {
          path: 'ThirdPartyLitigationTab4',
          name: 'ThirdPartyLitigationTab4',
          component: () => import('@/components/Admin/Butler/components/thirdparty_litigation/ThirdPartyLitigationTab4'),
          meta: {
            title: "第三方诉讼登记审核"
          }
        },
        {
          path: 'MeterMapEditor',
          name: 'MeterMapEditor',
          component: () => import('@/components/Admin/EnergyConsumption/components/meter/components/MeterMapEditor2'),
          meta: {
            title: "仪表架构编辑"
          }
        },
        {
          path: 'MeterOrderMap',
          name: 'MeterOrderMap',
          component: () => import('@/components/Admin/EnergyConsumption/components/meter_order/MeterOrderMap'),
          meta: {
            title: "能耗图"
          }
        },
        {
          path: 'MeterOrderFlow',
          name: 'MeterOrderFlow',
          component: () => import('@/components/Admin/EnergyConsumption/components/meter_order_flow/MeterOrderFlow'),
          meta: {
            title: "审批流程"
          }
        },
        {
          path: 'LegalPlanFlowList',
          name: 'LegalPlanFlowList',
          component: () => import('@/components/Admin/Butler/LegalPlanFlowList'),
          meta: {
            title: "催费计划审批"
          }
        },
        {
          path: 'LegalPlanFlowList',
          name: 'LegalPlanFlowList',
          component: () => import('@/components/Admin/Butler/LegalPlanFlowList'),
          meta: {
            title: "诉讼计划分配审批"
          }
        },
        {
          path: 'ExpeditingFeesPlanContenziosoShow',
          name: 'ExpeditingFeesPlanContenziosoShow',
          component: () => import('@/components/Admin/Butler/ExpeditingFeesPlanContenziosoShow'),
          meta: {
            title: "年度诉讼计划审核流程"
          }
        },
        {
          path: 'ExpeditingFeesPlanContenziosoAjustShow',
          name: 'ExpeditingFeesPlanContenziosoAjustShow',
          component: () => import('@/components/Admin/Butler/ExpeditingFeesPlanContenziosoAjustShow'),
          meta: {
            title: "年度诉讼计划审核流程"
          }
        },
        {
          path: 'ProjectCollectionThridPartyFlowBatchNumberList',
          name: 'ProjectCollectionThridPartyFlowBatchNumberList',
          component: () => import('@/components/Admin/Butler/components/thirdparty/ProjectCollectionThridPartyFlowBatchNumberList'),
          meta: {
            title: "诉讼计划分配审批"
          }
        },
      ]
    },
    {
      path: '/Meter/order/MeterList',
      component: () => import('@/components/Admin/Meter/order/MeterList'),
      meta: {
        title: '仪表（流程审批）'
      }
    },
    {
      path: '/Meter/order/MeterShareList',
      component: () => import('@/components/Admin/Meter/order/MeterShareList'),
      meta: {
        title: '虚拟表（分摊表流程审批）'
      }
    },
    {
      path: '/Order/order/flowOrderAdjust',
      component: () => import('@/components/Admin/Order/order/flowOrderAdjust'),
      meta: {
        title: '应收款调整流程'
      }
    },
    {
      path: '/Order/order/flowOrderAdjustDiscount',
      component: () => import('@/components/Admin/Order/order/flowOrderAdjustDiscount'),
      meta: {
        title: '应收款减免流程'
      }
    },
    {
      path: '/Order/order/flowOrderAdjustPayment',
      component: () => import('@/components/Admin/Order/order/flowOrderAdjustPayment'),
      meta: {
        title: '批量缴款/减免流程'
      }
    },
    {
      path: '/Order/order/flowOrderAdjustRedFlush',
      component: () => import('@/components/Admin/Order/order/flowOrderAdjustRedFlush'),
      meta: {
        title: '红冲流程'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js